<template>
    <div>
        <el-tabs v-model="activeTabName" @tab-click="handleTabClick">
            <!-- <el-tab-pane label="会员日" name="memberDay"></el-tab-pane> -->
            <el-tab-pane label="充值送" name="rechargeDelivery"></el-tab-pane>
            <el-tab-pane label="积分福利" name="memberPoints"></el-tab-pane>
        </el-tabs>
        <router-view class="router-view"></router-view>
    </div>
</template>

<script lang="ts">
import { createComponent, ref, Ref, reactive } from "@vue/composition-api"
import { routerUtil } from '@/utils/routerUtil'

export default createComponent({
    setup(props, ctx) {
        const {
            activeTabName,
            handleTabClick
        } = routerUtil(ctx)

        return {
            activeTabName,
            handleTabClick
        }
    }
})
</script>

<style lang="scss" scoped>
::v-deep .el-tabs__header {
    margin-bottom: 12px;
}

.router-view {
    height: calc(100vh - 145px);
}
</style>
